import {
  INPUT_CC_NUMBER,
  INPUT_CC_EXPIRATION_MONTH,
  INPUT_CC_EXPIRATION_YEAR,
  INPUT_CC_SECURITY_CODE,
  INPUT_FIRST_NAME,
  INPUT_LAST_NAME,
  INPUT_EMAIL_ADDRESS,
  INPUT_PHONE_NUMBER,
  INPUT_BILLING_ADDRESS,
  INPUT_BILLING_COUNTRY,
  INPUT_BILLING_ZIP,
  INPUT_BILLING_CITY,
  INPUT_BILLING_STATE,
  BILLING_STATUS_WAITING,
  BILLING_STATUS_PROCESSING,
  BILLING_STATUS_SUCCESS,
  BILLING_STATUS_FAILED
} from '../constants/billing'
import {
  USER_DETAILS_SUCCESS
} from '../actions/account'
import {
  FOCUS_INPUT,
  UPDATE_INPUT,
  DELETE_INPUT,
  ERROR_INPUT,
  BILLING_DETAILS_REQUEST,
  BILLING_DETAILS_SUCCESS,
  BILLING_DETAILS_FAILURE,
  UPDATE_BILLING_REQUEST,
  UPDATE_BILLING_SUCCESS,
  UPDATE_BILLING_FAILURE,
  SET_STATUS,
  FOCUS_KEYBOARD,
  SET_VALUE_INPUT
} from '../actions/billing'
import {
  COUNTRY_IDS,
  COUNTRIES_BY_ID,
  COUNTRY_CODES_BY_ID
} from '../constants/countries'
import { LOGIN_SUCCESS } from '../actions/login'
import { LOGOUT_SUCCESS } from '../actions/logout'

const INITIAL_STATE = {
  isReady: false,
  hasError: false,
  errorMessage: '',
  type: '',
  ccNo: '',
  ccExpYear: -1,
  ccExpMonth: -1,
  status: BILLING_STATUS_WAITING,
  focusedInput: INPUT_CC_NUMBER,
  keyboardFocused: true,
  focusedRow: 0,
  focusedCol: 0,
  errors: {},
  failedMessage: '',
  countries: COUNTRY_IDS,
  countriesById: COUNTRIES_BY_ID,
  countryCodesById: COUNTRY_CODES_BY_ID
}

INITIAL_STATE[INPUT_CC_NUMBER] = ''
INITIAL_STATE[INPUT_CC_EXPIRATION_MONTH] = 1
INITIAL_STATE[INPUT_CC_EXPIRATION_YEAR] = (new Date()).getFullYear()
INITIAL_STATE[INPUT_CC_SECURITY_CODE] = ''
INITIAL_STATE[INPUT_FIRST_NAME] = ''
INITIAL_STATE[INPUT_LAST_NAME] = ''
INITIAL_STATE[INPUT_EMAIL_ADDRESS] = ''
INITIAL_STATE[INPUT_PHONE_NUMBER] = ''
INITIAL_STATE[INPUT_BILLING_ADDRESS] = ''
INITIAL_STATE[INPUT_BILLING_COUNTRY] = -1
INITIAL_STATE[INPUT_BILLING_ZIP] = ''
INITIAL_STATE[INPUT_BILLING_CITY] = ''
INITIAL_STATE[INPUT_BILLING_STATE] = ''

INITIAL_STATE.errors[INPUT_CC_NUMBER] = ''
INITIAL_STATE.errors[INPUT_CC_EXPIRATION_MONTH] = ''
INITIAL_STATE.errors[INPUT_CC_EXPIRATION_YEAR] = ''
INITIAL_STATE.errors[INPUT_CC_SECURITY_CODE] = ''
INITIAL_STATE.errors[INPUT_FIRST_NAME] = ''
INITIAL_STATE.errors[INPUT_LAST_NAME] = ''
INITIAL_STATE.errors[INPUT_EMAIL_ADDRESS] = ''
INITIAL_STATE.errors[INPUT_PHONE_NUMBER] = ''
INITIAL_STATE.errors[INPUT_BILLING_ADDRESS] = ''
INITIAL_STATE.errors[INPUT_BILLING_COUNTRY] = ''
INITIAL_STATE.errors[INPUT_BILLING_ZIP] = ''
INITIAL_STATE.errors[INPUT_BILLING_CITY] = ''
INITIAL_STATE.errors[INPUT_BILLING_STATE] = ''

const billingReducer = (state = INITIAL_STATE, action) => {
  switch(action.type) {

    case USER_DETAILS_SUCCESS:
      return {
        ...state,
        [INPUT_FIRST_NAME]: action.payload.firstname,
        [INPUT_LAST_NAME]: action.payload.lastname,
        [INPUT_EMAIL_ADDRESS]: action.payload.email,
        [INPUT_PHONE_NUMBER]: action.payload.phone,
        [INPUT_BILLING_ADDRESS]: action.payload.address,
        [INPUT_BILLING_COUNTRY]: parseInt(action.payload.country_id, 10),
        [INPUT_BILLING_ZIP]: action.payload.zip,
        [INPUT_BILLING_CITY]: action.payload.city,
        [INPUT_BILLING_STATE]: action.payload.state
      }

    case FOCUS_INPUT:
      return {
        ...state,
        focusedInput: action.payload.focusedInput,
        focusedRow: action.payload.focusedRow,
        focusedCol: action.payload.focusedCol
      }
      case UPDATE_INPUT:
        if (state.focusedInput === INPUT_CC_NUMBER
          || state.focusedInput === INPUT_CC_EXPIRATION_MONTH
          || state.focusedInput === INPUT_CC_EXPIRATION_YEAR
          || state.focusedInput === INPUT_CC_SECURITY_CODE) {
          if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].indexOf(action.payload.newKey) === -1) {
            return state
          }
        }
        let newValue
        if (state.focusedInput === INPUT_EMAIL_ADDRESS && action.payload.newKey.indexOf('@') !== -1) {
          const atPos = state[state.focusedInput].indexOf('@')
          if (atPos !== -1) {
            newValue = state[state.focusedInput].substr(0, atPos) + action.payload.newKey
          } else {
            newValue = state[state.focusedInput] + action.payload.newKey
          }
        } else {
          newValue = state[state.focusedInput] + action.payload.newKey
        }
        return {
          ...state,
          [state.focusedInput]: newValue,
          errors: {
            ...state.errors,
            [state.focusedInput]: ''
          }
        }
      case DELETE_INPUT:
        return {
          ...state,
          [state.focusedInput]: state[state.focusedInput].substr(0, state[state.focusedInput].length - 1),
          errors: {
            ...state.errors,
            [state.focusedInput]: ''
          }
        }
      case ERROR_INPUT:
        return {
          ...state,
          errors: {
            ...state.errors,
            [action.payload.input]: action.payload.error
          }
        }
      case SET_STATUS:
        return {
          ...state,
          status: action.payload.status
        }
      case FOCUS_KEYBOARD:
        return {
          ...state,
          keyboardFocused: action.payload.focus
        }
      case SET_VALUE_INPUT:
        return {
          ...state,
          [action.payload.input]: action.payload.value
        }

    case BILLING_DETAILS_REQUEST:
      return {
        ...state,
        isReady: false,
        hasError: false,
        errorMessage: ''
      }
    case BILLING_DETAILS_SUCCESS:
      return {
        ...state,
        isReady: true,
        hasError: false,
        ccType: action.payload.payment_method_type,
        ccNo: action.payload.payment_method_number,
        ccExpYear: parseInt(action.payload.payment_method_exp_year, 10),
        ccExpMonth: parseInt(action.payload.payment_method_exp_month, 10)
      }
    case BILLING_DETAILS_FAILURE:
      return {
        ...state,
        isReady: true,
        hasError: true,
        errorMessage: action.payload.message
      }

    case UPDATE_BILLING_REQUEST:
      return {
        ...state,
        status: BILLING_STATUS_PROCESSING
      }
    case UPDATE_BILLING_FAILURE:
      return {
        ...state,
        status: BILLING_STATUS_FAILED,
        failedMessage: action.payload.message
      }
    case UPDATE_BILLING_SUCCESS:
      return {
        ...state,
        isReady: false,
        status: BILLING_STATUS_SUCCESS,
        [INPUT_CC_NUMBER]: '',
        [INPUT_CC_EXPIRATION_MONTH]: 1,
        [INPUT_CC_EXPIRATION_YEAR]: (new Date()).getFullYear(),
        [INPUT_CC_SECURITY_CODE]: ''
      }

    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
      return {
        ...INITIAL_STATE
      }

    default:
      return state
  }
}

export default billingReducer
